export function validateFormula(formula: string) {
  const result = {
    isValid: true,
    message: "",
  };

  let leftBracket = 0;
  let rightBracket = 0;
  let insideVariable = false;

  for (let index = 0; index < formula.length; index++) {
    const token = formula[index];

    if (token === "{") {
      insideVariable = true;
      continue;
    } else if (token === "}") {
      insideVariable = false;
      continue;
    }
    if (insideVariable) continue;

    if (token === "(") {
      leftBracket++;
      const lastToken = formula[index - 1];
      if (lastToken && !isOperator(lastToken)) {
        result.isValid = false;
        result.message = "Need operator before (";
        break;
      }
    } else if (token === ")") {
      rightBracket++;
      const nextToken = formula[index + 1];
      if (nextToken && !isOperator(nextToken)) {
        result.isValid = false;
        result.message = "Need operator after )";
        break;
      }
    } else if (isOperator(token)) {
      const lastToken = formula[index - 1];
      if (lastToken && isOperator(lastToken)) {
        result.isValid = false;
        result.message = `Adjacent operator now allowed: ${lastToken}, ${token}`;
        break;
      }
    } else if (isNumber(token)) {
    } else if (token === " ") {
    } else {
      result.isValid = false;
      result.message = `Invalid character: ${formula.slice(index)}`;
      break;
    }
  }

  if (result.isValid && leftBracket !== rightBracket) {
    result.isValid = false;
    result.message = "Mismating brackets";
  }

  if (insideVariable) {
    result.isValid = false;
    result.message = "Variable bracket not closed";
  }

  return result;
}

export function calculate(formula: string) {
  const outputQueue: Array<string> = [];
  const operatorStack: Array<string> = [];

  for (let index = 0; index < formula.length; index++) {
    const token = formula[index];

    if (isNumber(token)) {
      let number = token;
      while (isNumber(formula[++index])) {
        number += formula[index];
      }
      outputQueue.push(number);
      index--;
    } else if (isOperator(token)) {
      while (
        operatorStack.at(-1) &&
        operatorStack.at(-1) !== "(" &&
        (getPrecedence(operatorStack.at(-1)!) > getPrecedence(token) ||
          (getPrecedence(operatorStack.at(-1)!) === getPrecedence(token) &&
            getAssociativity(token) === "left"))
      ) {
        const output = performOperation(outputQueue, operatorStack);
        outputQueue.push(String(output));
      }
      operatorStack.push(token);
    } else if (token === "(") {
      operatorStack.push("(");
    } else if (token === ")") {
      while (operatorStack.at(-1) && operatorStack.at(-1) !== "(") {
        const output = performOperation(outputQueue, operatorStack);
        outputQueue.push(String(output));
      }
      operatorStack.pop();
    }
  }

  for (const _ of operatorStack) {
    const output = performOperation(outputQueue, operatorStack);
    outputQueue.push(String(output));
  }

  return outputQueue[0];
}

interface Operator {
  precedence: number;
  associativity: "left" | "right";
}

const OPERATORS: Record<string, Operator> = {
  "^": {
    precedence: 13,
    associativity: "right",
  },
  "*": {
    precedence: 12,
    associativity: "left",
  },
  "/": {
    precedence: 12,
    associativity: "left",
  },
  "%": {
    precedence: 12,
    associativity: "left",
  },
  "+": {
    precedence: 11,
    associativity: "left",
  },
  "-": {
    precedence: 11,
    associativity: "left",
  },
};

function performOperation(
  outputQueue: Array<string>,
  operatorStack: Array<string>,
) {
  const operator = operatorStack.pop();
  const secondOperand = outputQueue.pop();
  const y = isNaN(Number(secondOperand)) ? 0 : Number(secondOperand);

  if (operatorStack.at(-1) === "(") {
    return operator === "-" ? y * -1 : y;
  }

  const firstOperand = outputQueue.pop();
  const x = isNaN(Number(firstOperand)) ? 0 : Number(firstOperand);

  switch (operator) {
    case "^": {
      return x ** y;
    }
    case "*": {
      return x * y;
    }
    case "/": {
      return x / y;
    }
    case "%": {
      return x % y;
    }
    case "+": {
      return x + y;
    }
    case "-": {
      return x - y;
    }
  }

  return 0;
}

function isNumber(token: string) {
  return token === "." || (token !== " " && !isNaN(Number(token)));
}

function isOperator(token: string) {
  return token in OPERATORS;
}

function getPrecedence(operator: string) {
  return OPERATORS[operator].precedence;
}

function getAssociativity(operator: string) {
  return OPERATORS[operator].associativity;
}
